import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { iframeResizer } from 'iframe-resizer';

const StyledIframe = styled.iframe`
  border: none;
  width: 1px;
  min-width: 100%;
`;

const IFrame = ({ iFrame }: { iFrame: string | undefined }) => {
  const iframeRef = useRef<any>(null);
  const [iframeProps, setIframeProps] = useState([]);

  useEffect(() => {
    if (!iFrame) {
      return;
    }

    const iframe = iframeRef.current;

    const doc = document.createElement('div');
    doc.innerHTML = iFrame;

    const iframeAttrs = doc.getElementsByTagName('iframe')[0];

    const attrs = [].slice
      .call(iframeAttrs.attributes)
      .reduce((attrs: any, element: any) => {
        attrs[element.name] = element.value;

        return attrs;
      }, {});

    const minHeight =
      parseInt(attrs['min-height'], 10) > 0
        ? parseInt(attrs['min-height'], 10)
        : 0;

    iframeResizer({ checkOrigin: false, minHeight }, iframe);

    delete attrs.style;
    setIframeProps(attrs);

    return () =>
      iframe && iframe.iFrameResizer && iframe.iFrameResizer.removeListeners();
  }, [iFrame]);

  return iFrame ? (
    <StyledIframe
      title="Iframe"
      ref={iframeRef}
      loading="lazy"
      {...iframeProps}
    />
  ) : null;
};

export default IFrame;
